/* eslint-disable camelcase */
import { getAffiliateFromCookie } from 'src/utils/affiliate'

export function getAffiliateTrackingFromCookie() {
  const affiliateData = getAffiliateFromCookie()

  const { it_cmp, it_tpl, ...rest } = affiliateData

  return {
    ...rest,
    itbl_cmp: affiliateData?.it_cmp || '',
    itbl_tpl: affiliateData?.it_tpl || '',
    refid: affiliateData?.refid || '',
  }
}
